import React from "react";
import {useForm, FormProvider} from "react-hook-form";

import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

import * as ClientFragment from './ClientFragmentComponent';

function ClientFullRenderer(props) {
    const methods = useForm({
        defaultValues: {
            lClient: props.client
        } 
    });

    const handleSubmitEData = (data) => {
        const client = data.lClient;
        props.saveClient(client);
    }

    return(
        <React.Fragment>
            <FormProvider {...methods} > 
            <form onSubmit={methods.handleSubmit( handleSubmitEData )} id={'clientForm'}>

                {/**********   Date Generale   **********/}
                <ClientFragment.RenderGeneralSection />
                <ClientFragment.RenderCompanySection />

                {/**********   Adresa Sediu    **********/}
                <ClientFragment.RenderAdresaSediuSection />

                <Box sx={{ width:'100%', marginBottom: 2, marginTop: 1}} display="flex" justifyContent="flex-end" alignItems="flex-end">
                    <Button variant="outlined" type="submit" sx={{ marginRight: 1}}>Salveaza Client</Button>
                </Box>
    
            </form>
            </FormProvider>
        </React.Fragment>
    );
}

export default ClientFullRenderer